import cn from 'classnames';
import styles from './Socials.module.scss';
import {Link} from "../Link/Link";

import finish from '../../resources/finish.jpg'

import {ReactComponent as Vk} from '../../resources/vk.svg';
import {ReactComponent as Ok} from '../../resources/ok.svg';
import {ReactComponent as Tg} from '../../resources/tg.svg';

const iconsList = [<Vk/>, <Ok/>, <Tg/>];

const socials = [
    {id: 0, link: 'https://vk.com/2x2tv', sharing: `https://vk.com/share.php?url=${window.location.href}&title=${process.env.REACT_APP_TITLE}&comment=%23квестуха2x2`, text: 'ВК'},
    {id: 1, link: 'https://ok.ru/2x2tv', sharing: `https://connect.ok.ru/offer?url=${window.location.href}&title=${process.env.REACT_APP_TITLE}`, text: 'ОК'},
    {id: 2, link: 'https://t.me/telekanal2x2', sharing: `https://t.me/share/url?url=${window.location.href}&text=${process.env.REACT_APP_TITLE}`, text: 'ТГ'}
];

const socialsImage = [
    {id: 0, link: 'https://vk.com/2x2tv', sharing: `https://vk.com/share.php?url=${window.location.href}&title=${process.env.REACT_APP_TITLE}&comment=%23квестуха2x2&image=${window.location.origin}${finish}`, text: 'ВК'},
    {id: 1, link: 'https://ok.ru/2x2tv', sharing: `https://connect.ok.ru/offer?url=${window.location.href}&title=${process.env.REACT_APP_TITLE}&imageUrl=${window.location.origin}${finish}`, text: 'ОК'},
    {id: 2, link: 'https://t.me/telekanal2x2', sharing: `https://t.me/share/url?url=${window.location.href}&text=${process.env.REACT_APP_TITLE}`, text: 'ТГ'}
];

export const Socials = ({className, share = false, footer = false, icons}) => {
    const socialsList = socials.map(item => {
        const {id, link, sharing, text} = item;

        const sharingLink = share && !footer ? socialsImage[id].sharing : sharing;

        return (
            <li className={styles.item} key={id}>
                <Link link={share ? sharingLink : link} text={text} className={cn(styles.link)}>{icons ? iconsList[id] : null}</Link>
            </li>
        )
    });

    return (
        <ul className={cn(styles.socials, footer ? styles.footer : '', className)}>
            {socialsList}
        </ul>
    )
}